import PropTypes from "prop-types"
import { useFormik } from "formik"
import * as Yup from "yup"
import React, { useState, useEffect } from "react"
//redux
import { useDispatch, useSelector } from "react-redux"
import {
  Card,
  CardBody,
  Col,
  Row,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { setIsMobile } from "store/actions"
import TableContainer from "./table"
import { StartDateactivity } from "pages/Reports/VerifyMyTeams/VerifyScreenCol"
import {
  getWebHookProcessList,
  getWebHook,
  getWebHookInsert,
  getWebHookUpdate,
  getWebHookDelete,
} from "store/webHooks/action"
import HeaderWeebHook from "./HeaderWeebHook"
import moment from "moment"
import toast from "toastr"
import DeleteModal from "components/Common/DeleteModal"

const Index = () => {
  document.title = "Web Hooks | TenderSoftware - Flexi TracBoard"
  const [webHookList, setWebHookList] = useState([])
  const [selectedWebHookData, setSelectedWebHookData] = useState([])
  const [deleteHook, setDeleteHook] = useState(false)
  const [deleteHookID, setDeleteHookID] = useState(null)

  const dispatch = useDispatch()

  useEffect(() => {
    // dropdown list webhook
    dispatch(getWebHookProcessList())
    // get overall table dta
    dispatch(getWebHook())

    const handleResize = () => {
      dispatch(setIsMobile(window.innerWidth < 921))
    }
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  const {
    isMobile,
    WebHookData,
    webhookListdata,
    updateWebHook,
    insertWebHook,
    deleteWebHook,
  } = useSelector(state => ({
    isMobile: state?.teams?.isMobile,
    webhookListdata: state?.Webhook?.webHooksprocessSuccessList?.datas,
    WebHookData: state?.Webhook?.webHooksSuccessList?.datas,
    updateWebHook: state?.Webhook?.webHooksupdateSuccessList,
    insertWebHook: state?.Webhook?.webHooksinsertSuccessList,
    deleteWebHook: state?.Webhook?.webHooksdeleteSuccessList,
  }))

  useEffect(() => {
    // get overall table data
    if (
      updateWebHook?.statusCode == 200 ||
      insertWebHook?.statusCode == 200 ||
      deleteWebHook?.statusCode == 200
    ) {
      dispatch(getWebHook())
      setSelectedWebHookData([])
      validation.resetForm()
    }
  }, [updateWebHook, insertWebHook, deleteWebHook])

  useEffect(() => {
    const reportsX = (WebHookData || [])?.map(el => {
      return {
        ...el,
        id: el.id,
        webUrl: el?.webhookurl,
        processId: webhookListdata
          ?.filter(usr => usr.processname === el.processname)
          .map(el => el.id)[0],
      }
    })
    setWebHookList(reportsX)
  }, [WebHookData])

  const handleEditWebhook = list => {
    setSelectedWebHookData(list)
  }

  // delelete modal create
  const handleDeleteWebhook = id => {
    setDeleteHookID(id)
    setDeleteHook(true)
  }

  // delete action confirmation
  const handleDeleteWebhookId = () => {
    if (deleteHookID) {
      dispatch(getWebHookDelete(deleteHookID))
      setDeleteHook(false)
    }
  }

  // table columns
  const columns = React.useMemo(() => {
    const result = [
      {
        Header: "Process",
        accessor: "processname",
        disableFilters: true,
        sort: true,
      },
      {
        Header: "Web Hook Url",
        accessor: "webhookurl",
        disableFilters: true,
        sort: true,
      },
      {
        Header: "Created Date",
        accessor: "createddate",
        disableFilters: true,
        sort: true,
        Cell: cellProps => {
          return <StartDateactivity {...cellProps} />
        },
      },
      {
        Header: "Action",
        width: 80,
        Cell: cellProps => {
          return (
            <div role="buttton" style={{ cursor: "Pointer" }}>
              <UncontrolledDropdown>
                <DropdownToggle href="#" className="card-drop" tag="i">
                  <i className="mdi mdi-dots-vertical font-size-18" />
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                  <DropdownItem
                    href="#"
                    onClick={() => handleEditWebhook(cellProps.row.original)}
                  >
                    Edit
                  </DropdownItem>
                  <DropdownItem
                    href="#"
                    onClick={() =>
                      handleDeleteWebhook(cellProps.row.original?.id)
                    }
                  >
                    Delete
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          )
        },
      },
    ]
    return result
  }, [webHookList, isMobile])

  const SelectedProcessName = {
    value: selectedWebHookData?.processId,
    label: selectedWebHookData?.processname,
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      processname: selectedWebHookData?.id
        ? selectedWebHookData && SelectedProcessName
        : "",
      webhookurl: selectedWebHookData?.id
        ? selectedWebHookData && selectedWebHookData?.webhookurl
        : "",
    },
    validationSchema: Yup.object({
      webhookurl: Yup.string()
        .url("Invalid URL format")
        .required("Please Enter webhook Url"),
      processname: Yup.object().required(`Please Select Process Name`),
    }),

    onSubmit: async values => {
      try {
        if (selectedWebHookData?.id) {
          const updateWebhooks = {
            id: selectedWebHookData.id,
            webhookUrl: values.webhookurl,
            createdDate: moment().format("YYYY-MM-DD"),
            processId: values?.processname?.value,
          }
          // Dispatch update action
          dispatch(getWebHookUpdate(updateWebhooks))
        } else {
          const duplicateValueCondition = webHookList?.find(
            usr => usr.processId === values.processname?.id
          )
          if (duplicateValueCondition) {
            throw new Error(`${values.processname?.processname} Already Exit`)
          }
          const newWebhooks = {
            id: 0,
            webhookUrl: values.webhookurl,
            createdDate: moment().format("YYYY-MM-DD"),
            processId: values.processname?.id,
          }
          // Dispatch new action
          await dispatch(getWebHookInsert(newWebhooks))
        }
      } catch (error) {
        toast.error(error.message)
      }
    },
  })
  
  //  update value remove in cancel button decleare
  const removeWebhookData = () => {
    setSelectedWebHookData([])
  }

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteHook}
        onDeleteClick={handleDeleteWebhookId}
        onCloseClick={() => setDeleteHook(false)}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title={"Web Hooks"} breadcrumbItem={"Web Hooks"} />
          <Card>
            <CardBody>
              <HeaderWeebHook
                validation={validation}
                webhookListdata={webhookListdata}
                selectedWebHookData={selectedWebHookData}
                removeWebhookData={removeWebhookData}
              />
              <Row>
                <Col xs="12">
                  <div className="p-0 table-mobileView">
                    <>
                      <TableContainer
                        keyField="empId"
                        columns={columns}
                        data={webHookList}
                        isMobile={isMobile}
                        customPageSize={10}
                        totalCount={webHookList?.length || 0}
                        className="custom-header-css"
                      />
                    </>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

Index.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default Index
